import React from "react"
import { Articles } from "../data/articles"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import CategoryLink from "./category-link";

export default () => (
  <div id="aside">
    <div id="text-4" className="widget widget_text about">
      <h2 className="widget-title">
        <span>About me</span>
      </h2>
      <div className="textwidget">
        <p className="text-about">
          Hello! My name is <strong>Mihai</strong> and I am a software
          professional from Bucharest, Romania, working on challenging and
          rewarding projects.
          <br />
          <br />
          I enjoy helping people and businesses evolve.
          <br />
          <br />
          My experience ranges from software architecture, delivery of complex
          SPAs, high-availability &amp; high-traffic websites to software
          process improvement, team management and people mentoring.
          <br />
          <br />
          Currently working with Node, React, TypeScript, Mongo, ElasticSearch,
          Kubernetes, GCloud
        </p>
      </div>
    </div>
    <div id="wpp-3" className="widget popular-posts post-dates">
      <h2 className="widget-title">
        <span>Recent Articles</span>
      </h2>
      <ol>
        {Articles.getLatest(5).map(article => (
          <li className="cat-item" key={article.link}>
            <AniLink fade to={article.link}>
              {article.title}
              <span className="wpp-date">
                Posted on{" "}
                {article.date.toLocaleString("en-us", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </AniLink>
          </li>
        ))}
      </ol>
    </div>
    <div id="categories-3" className="widget widget_categories categories">
      <h2 className="widget-title">
        <span>Categories</span>
      </h2>
      <ul>
        {Articles.getUniqueCategories(5).map(cat => (
          <li className="cat-item" key={cat}>
            <CategoryLink cat={cat} />
          </li>
        ))}
      </ul>
    </div>
  </div>
)
